import { Box, Card } from '@factorialco/deprecated-design-system'
import { EmployeeTimePeriodDetailsFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import PlannedTimeTable from './PlannedTimeTable'

interface Props {
  timePeriodDetails: EmployeeTimePeriodDetailsFragment[]
  rangeType: string
  loading: boolean
  convertHours: boolean
}

const PlannedTime = ({ timePeriodDetails, rangeType, loading, convertHours }: Props) => {
  const title = i18n.t('shift_management.time_insights.time_balance_content.planned_time.title')
  const tooltip = i18n.t('shift_management.time_insights.time_balance_content.planned_time.tooltip')

  return (
    <Card>
      <Card.Title tooltip={tooltip}>{title}</Card.Title>
      <Card.Content>
        <Box paddingY="s16">
          <PlannedTimeTable
            timePeriodDetails={timePeriodDetails}
            rangeType={rangeType}
            loading={loading}
            convertHours={convertHours}
          />
        </Box>
      </Card.Content>
    </Card>
  )
}

export default observer(PlannedTime)
